import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PaymentHistoryIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PaymentHistoryIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M3 12C3 13.78 3.52784 15.5201 4.51677 17.0001C5.50571 18.4802 6.91131 19.6337 8.55585 20.3149C10.2004 20.9961 12.01 21.1743 13.7558 20.8271C15.5016 20.4798 17.1053 19.6226 18.364 18.364C19.6226 17.1053 20.4798 15.5016 20.8271 13.7558C21.1743 12.01 20.9961 10.2004 20.3149 8.55585C19.6337 6.91131 18.4802 5.50571 17.0001 4.51677C15.5201 3.52784 13.78 3 12 3C9.48395 3.00947 7.06897 3.99122 5.26 5.74L3 8"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3V8H8"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0866 9.8689C13.7931 9.47969 13.3871 9.19007 12.9236 9.0391C12.4601 8.88814 11.9614 8.88306 11.4949 9.02475C9.69358 9.42866 9.59045 11.8699 11.9914 11.7905C14.3924 11.711 14.7769 13.6444 13.5933 14.5247C13.3137 14.7206 12.9975 14.8583 12.6635 14.9295C12.3296 15.0008 11.9847 15.0041 11.6495 14.9393C11.3142 14.8746 10.9954 14.743 10.7121 14.5525C10.4287 14.362 10.1865 14.1164 9.99995 13.8305"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M12.1207 7.00018V8.58338"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M12.1207 15.3709V16.6214"
        stroke="#503291"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default PaymentHistoryIcon
